import { render, staticRenderFns } from "./Precalificador.vue?vue&type=template&id=bcf442a6&"
import script from "./Precalificador.vue?vue&type=script&lang=js&"
export * from "./Precalificador.vue?vue&type=script&lang=js&"
import style0 from "./Precalificador.vue?vue&type=style&index=0&id=bcf442a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports